import Vue from 'vue'
import './components'
import vuetify from './plugins/vuetify'
import App from './layouts/App.vue'
import router from './components/router/index.js'
import store from './store'
import DateFilter from './filters/date'
import { auth } from './firebase'
import AlertComponent from './components/shared/Alert.vue'
import { layoutForPath } from './utils/app-layout'
import { applyIabfDocumentChrome } from './config/iabf-brand'

Vue.config.productionTip = false
applyIabfDocumentChrome()

Vue.filter('date', DateFilter)
Vue.component('app-alert', AlertComponent)

router.beforeEach((to, from, next) => {
  const nextLayout = layoutForPath(to.path)
  const current = store.getters.layout
  // Pages that opt into embed-layout (login ?embed, showcase) should keep
  // it across query-only navigations on the same path.
  if (current === 'embed-layout' && to.path === from.path) {
    next()
    return
  }
  if (current !== nextLayout) {
    store.commit('setLayout', nextLayout)
  }
  next()
})

new Vue({
  router,
  store,
  vuetify,
  created () {
    auth.onAuthStateChanged((user) => {
      if (user) {
        this.$store.dispatch('autoSignIn', user)
      }
    })
  },
  render: h => h(App)
}).$mount('#app')
